import { app } from '../../../../../../../app';
import { Controller } from './confirm-assign.controller';

app.component('companyUserDirectoriesManageUserDetailsAssignHardTokenConfirmAssign', {
    controller: Controller,
    templateUrl: require('./confirm-assign.html'),
    bindings: {close: '&', dismiss: '&', resolve: '<'},
});



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-user/details/assign-hard-token/confirm-assign/confirm-assign.component.js